export const RECORDER_ERR_ENUM = {
  OK: 200, // 正常
  INVALID_ARGUMENT: 400, // 无效参数
  NOT_FOUND: 404, // 未找到对应资源
  ALREADY_EXISTS: 409, // 创建的资源已存在
  ABORTED: 409, // 并发冲突
  CANCELLED: 499, // 请求被取消
  UNKNOWN: 500, // 未知错误
  NOT_IMPLEMENTED: 501// 未装配API
};
const canvasMap = new WeakMap();
/**
 * @description 提供一套canvas录制工具
 */
export function useCanvasRecorder() {
  return useRecorder((canvas) => {
    // 获取实际的canvas 元素
    const el = typeof canvas === 'string' ? document.querySelector(canvas) : canvas;
    /** @type  {MediaStream} */
    let stream;
    // 开始录制
    if (canvasMap.has(el)) {
      stream = canvasMap.get(el);
    } else {
      stream = canvas.captureStream(25);
    }
    return stream;
  });
}
/**
 * @param {()=>MediaStream} getSteams
 */
function useRecorder(getSteams) {
  /**
    * @type {MediaRecorder|null}
    */
  let recorder;
  let doCancel;
  function clear() {
    recorder && recorder.stream.getTracks().forEach(track => track.stop());
    recorder = null;
    doCancel = null;
  }
  /**
 * @description 录制一个canvas视频
 * @param {HTMLCanvasElement|string} canvas
 * @returns {Promise<Blob>}
 */
  function start(...arg) {
    return new Promise((resolve, reject) => {
      let isCancel = false;
      /** @type  {MediaStream} */
      const stream = getSteams(...arg);
      const chucks = [];
      recorder = new MediaRecorder(stream, { mimeType: "video/webm" });
      recorder.addEventListener('dataavailable', (e) => {
        chucks.push(e.data);
      });
      recorder.addEventListener('stop', () => {
        if (!isCancel) {
          const blob = new Blob(chucks, { type: 'video/webm' });
          resolve(blob);
        } else {
          reject(RECORDER_ERR_ENUM.CANCELLED);
        }
        clear();
      });
      recorder.addEventListener('error', (err) => {
        reject(err);
        clear();
      });
      doCancel = () => {
        isCancel = true;
        recorder.stop();
      };
      recorder.start();
    });
  }
  function stop() {
    recorder && recorder.stop();
  }
  function cancel() {
    doCancel && doCancel();
  }
  return {
    start, cancel, stop,
    supported: MediaRecorder.isTypeSupported('video/webm')
  };
}
